<div class="pageWrapper">
  <!-- <div class="pageHeader">
      <img src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FbranchHiringEvents%2Fphoenix%2Fbanner_image_mullet_arena.png?alt=media&token=ce2f1612-f876-4543-9818-78158109c36b" alt="Mullet arena" />
    </div> -->
  <div class="pageHeader">
    <!-- <ng-container *ngIf="stadiumAssets | async">
        <ng-container *ngFor="let x of stadiumAssets | async">
        <img [src]="x.bannerImage" alt="{{x.altText}}">
        </ng-container>
      </ng-container> -->

    <a href=" https://hportal.schedulingsite.com/verifyemailAdd/12" target="_blank" rel="noopener noreferrer"
      rel="noopener noreferrer">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FbranchHiringEvents%2FNorthernCalifornia%2FNFL%20BRANDED%20-%20SUPER%20BOWL%20HIRING%20EVENT%20-%20AD%20-%20FACEBOOK%20POST%20LANDSCAPE%20(2).png?alt=media&token=3908fa86-87f0-44a9-834f-ae3c6e6aae93"
        alt="CSC Norcal SB LX" />
    </a>
  </div>
  <ng-container>

    <!-- <div class="pageTitle">
      <h1>
        <span class="cscMidnightBlueText">CSC </span>
        <span class="cscMidnightBlueText">Northern California</span>
      </h1>
      <span class="divider"> </span>
       <h2>
      <span class="cscMidnightBlueText ">Now</span
      ><span class="cscMidnightBlueText "> Hiring for The Big Game on February 8th!</span>
    </h2>
    </div> -->


    <!-- <div class="video">
          <iframe src="https://player.vimeo.com/video/695898281?h=4612fba397"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        </div> -->

    <div class="columnsWrapper">
      <!-- <div class="stateFair">
          <div class="eventTitle">
            <h3>MULLET ARENA</h3>
          </div>
          <div class="imageWrapper">
         <img src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FbranchHiringEvents%2Fphoenix%2Fmullet_arena.png?alt=media&token=1b2ca849-9356-4175-a71b-c7d8db61acd2" alt="MULLET ARENA">
            </div>
            <div class="copyIntro">
          <p>Join the experience this Fall at ASU's new multipurpose center - Mullett Arena!
          </p>
            <p>Now hiring Event Security positions for some spectacular upcoming events including ASU hockey and gymnastics, community events, as well as professional hockey games for the Arizona Coyotes.
          </p>
        </div>
        <div class="applyBtn">
          <a
            href="https://hportal.schedulingsite.com/verifyemailAdd/504"
            target="_blank"
            rel="noopener noreferrer"
            rel="noopener noreferrer"
          >
            <button class="cscGoldBtnInverse" mat-raised-button>
              APPLY NOW!
            </button>
          </a>
        </div>
        </div> -->
  <div class="video">
        <div id="locationsVideo" class="locationsVideoWrapper" style="position: relative;">
           <video width="100%" height="auto" controls autoplay loop [muted]="'muted'">
            <source
              src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FbranchHiringEvents%2FNorthernCalifornia%2FCSC_SBLX_Hiring_Event_30sec_Spot.mp4?alt=media&token=99b5c38a-16eb-467e-a81a-c06181cdaf5f"
              type="video/mp4">
          </video>
          <!-- <iframe src="https://player.vimeo.com/video/770891963?app_id=122963" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Super Bowl LVII" data-ready="true"></iframe> -->
         </div>
      </div>
      <div class="superBowl">
       
        <div class="eventTitle">
          <h2>
            <!-- NOW <span class="cscMidnightBlueText" style="font-weight: bolder;"> HIRING </span> FOR<br> -->
            <!-- <span  style="font-weight: bolder;">SUPER BOWL LVIII </span> -->
            <span class="cscMidnightBlueText" style="font-weight: bolder;">CSC NFL Hiring Event — Levi's® Stadium (Nov 15) </span> </h2>
        </div>
        <!-- <div class="imageWrapper">
                    <img src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/corporate%2Fimages%2Fwebsite%2FbranchHiringEvents%2Flasuperbowl2023%2FSuper_Bowl_LVIII_logo.png?alt=media&token=d64bb59b-520c-4bd3-a2fb-cb76fe942b7f"
                        alt="Super Bowl 2023">
                 
                </div> -->
        <div class="copyIntro" style="text-align: left;margin: 0px -1px;width: 100%;max-width: 100%;padding: 0px 30px;">
          <!-- <p class="join-content">
            <strong>Be part of the team delivering world-class guest experiences for Super Bowl LX and major Bay Area events.</strong>
            Step onto the biggest stage in sports and experience the excitement from the front lines. This February 8th,
            <strong>CSC invites you to be part of the elite team at Levi's Stadium in Santa Clara.</strong>  Flexible hours,
            unforgettable energy, and a chance to say you worked the <i style="vertical-align: baseline; font-size: initial;">BIG GAME</i>  Don't just watch the action — <strong>be in it.</strong> 
          </p> -->
        
          <h2 class="cscMidnightBlueText" style="margin-bottom: 25px; margin-top:25px"><u>WHY JOIN CSC FOR SUPER SUNDAY?</u></h2>
          <h3>Competitive Pay:</h3>
          <p class="join-content">Earn <strong>$22.00 to $26.00 per hour </strong> working at the biggest event of the year! </p>
          <h3>Real Benefits:</h3>
          <ul class="join-content" style="margin-top: 5px;">
            <li><strong>401(k) Matching</strong> - Invest in your future with every paycheck</li>
            <li><strong>Employee Stock Ownership Plan (ESOP)</strong> - Become a part-owner in CSC after qualifying hours</li>
            <li><strong>Flexible Scheduling</strong> - Pick shifts that work for you</li>
          </ul>
          <!-- <p class="join-content"><strong>401(k) Matching</strong> - Invest in your future with every paycheck</p>
          <p class="join-content"><strong>Employee Stock Ownership Plan (ESOP)</strong> - Become a part-owner in CSC after qualifying hours</p>
          <p class="join-content"><strong>Flexible Scheduling</strong> - Pick shifts that work for you</p> -->
          <h3>Exclusive Perks:</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li><strong>Game Day Memorabilia </strong> - Yours to keep as souvenir</li>
            <li><strong>Free Meals on Game Day </strong> - Stay energized while you work</li>
            <li><strong>Unforgettable Experience</strong> - Be part of a once-in-a-lifetime event at Levi's Stadium</li>
          </ul>
             <div class="applyBtn">
            <a href=" https://hportal.schedulingsite.com/verifyemailAdd/12" target="_blank" rel="noopener noreferrer"
              rel="noopener noreferrer">
              <button class="cscGoldBtnInverse" mat-raised-button>
                CLICK HERE TO APPLY
              </button>
            </a>
          </div>
           <p class="join-content">
            <strong>Be part of the team delivering world-class guest experiences for Super Bowl LX and major Bay Area events.</strong>
            Join Contemporary Services Corporation (CSC) at Levi's Stadium for our in-person hiring event on 
            <strong>Saturday November 15. Hiring Security Guards and access control staff - staff must have or be in the process to attain a CA Security License</strong> 
          </p>
          <h3>What to Expect</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li><strong>On-site interviews </strong> for game-day roles: Security, Access Control, Overnight Security Staff, Premium & Club Support, and More</li>
            <li><strong>Fast-track hiring </strong> for qualified candidates working Super Bowl LX operations and upcoming events</li>
            <li><strong>Meet CSC leaders </strong>and learn about training, scheduling, and event assignments</li>
          </ul>
          <h3>Event Details</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li><strong>Date:</strong> Saturday, November 15</li>
            <li><strong>Location:</strong>Levi's Stadium, Santa Clara, CA (exact check-in location provided after registration)</li>
            <li><strong>Time:</strong>10am to 4pm</li>
            <li>Parking/Check - Park int the North Structure Yellow 1 and walk across to Gate F </li>
          </ul>
          <p>
            <img src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FbranchHiringEvents%2FNorthernCalifornia%2FYellow-1-to-Gate-F-Directions.jpg?alt=media&token=01275364-74f4-4b76-a26b-2fe497fc8f7f" style="max-width: 100%;">
          </p>
            <h3>What to Bring</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li><strong>Two (2) acceptable I-9 documents </strong>(physical, unexpired) for employment eligibility verification
              <ul>
                <li>Examples:
                  <ul>
                    <li>Photo ID <strong>and</strong>Social Security Card, <strong>or</strong></li>
                    <li>Photo ID <strong>and</strong> Birth Certificate, <strong>or</strong></li>
                    <li>Valid Passport</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>A <strong>mobile device</strong> to complete digital forms </li>
          </ul>
          <h3>Minimum Requirements</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li>18+ years of age (or per venue policy)</li>
            <li>Eligible to work in the U.S.</li>
            <li>Able to stand/walk for extended periods and follow guest-service protocols</li>
            <li>Availability for event days; training is required prior to first shift</li>
            <li ><strong> <i style="vertical-align:baseline">Must have or in the process of attaining a valid CA Security License</i> </strong></li>
          </ul>
           <h3>How to Register</h3>
           <ul class="join-content" style="margin-top: 5px;">
            <li><strong>•	Reserve your time slot </strong>using the registration link and select SAT Nov 15th as your preferred interview date</li>
          </ul>
            <!-- <p class="join-content"><strong>Custom Game Day Uniform</strong> - Yours to keep as a souvenir</p>
          <p class="join-content"><strong>Free Meals on Game Day</strong> - Stay energized while you work</p>
          <p class="join-content"><strong>Unforgettable Experience</strong> - Be part of a once-in-a-lifetime event at Levi's Stadium</p> -->
          <!-- <p class="join-content"> Now hiring Event Staff, Access Control, Security Guards and MORE! Must register by Nov 1<sup>st</sup> to Qualify!</p> -->
          <div class="applyBtn">
            <a href=" https://hportal.schedulingsite.com/verifyemailAdd/12" target="_blank" rel="noopener noreferrer"
              rel="noopener noreferrer">
              <button class="cscGoldBtnInverse" mat-raised-button>
                 CLICK HERE TO APPLY
              </button>
            </a>
          </div>
         
        
          
        </div>
      </div>
     
      <!-- Vimeo video section  -->
      <!-- <ng-container *ngIf="showVideoSection">
                  <div class="video">
                      <div id="locationsVideo" class="locationsVideoWrapper">
                      </div>
                  </div>
              </ng-container> -->
      <!-- <ng-container *ngIf="!showVideoSection">
        <div class="video">
          <h2 style="text-align: center;">Loading video...</h2>
        </div>
      </ng-container> -->



      <div class="video" style="display: none;">
        <div class="volumeButtons">
          <ng-container *ngIf="showMuteBtn">
            <!-- <button class="redBtn" mat-raised-button (click)="muteVolume()" id="muteVolume"><span
                class="material-icons">
                volume_up
              </span> Mute</button> -->
          </ng-container>
          <ng-container *ngIf="showUnmuteBtn">
            <button class="greenBtn" mat-raised-button (click)="unmuteVolume()" id="unmuteVolume"><span
                class="material-icons">
                volume_off
              </span> Unmute</button>
          </ng-container>
        </div>
        <!-- <div id="locationsVideo" class="locationsVideoWrapper">
              </div> -->
      </div>

    </div>
  </ng-container>

</div>